__turbopack_context__.v({
  "closeCodonationModalButton": "CodonationSelection-module__aKOhcq__closeCodonationModalButton",
  "codonationAddition": "CodonationSelection-module__aKOhcq__codonationAddition",
  "codonationFormWrapper": "CodonationSelection-module__aKOhcq__codonationFormWrapper",
  "delayTransition": "CodonationSelection-module__aKOhcq__delayTransition",
  "fakeInput": "CodonationSelection-module__aKOhcq__fakeInput",
  "illustration": "CodonationSelection-module__aKOhcq__illustration",
  "image": "CodonationSelection-module__aKOhcq__image",
  "inputAndSum": "CodonationSelection-module__aKOhcq__inputAndSum",
  "inputFlexContainer": "CodonationSelection-module__aKOhcq__inputFlexContainer",
  "inputWrapper": "CodonationSelection-module__aKOhcq__inputWrapper",
  "modal": "CodonationSelection-module__aKOhcq__modal",
  "modalTrigger": "CodonationSelection-module__aKOhcq__modalTrigger",
  "modalTriggerContainer": "CodonationSelection-module__aKOhcq__modalTriggerContainer",
  "previousImage": "CodonationSelection-module__aKOhcq__previousImage",
  "rangeInput": "CodonationSelection-module__aKOhcq__rangeInput",
  "slider": "CodonationSelection-module__aKOhcq__slider",
  "storeAndCloseButton": "CodonationSelection-module__aKOhcq__storeAndCloseButton",
  "sum": "CodonationSelection-module__aKOhcq__sum",
  "visibleImage": "CodonationSelection-module__aKOhcq__visibleImage",
  "zeroCodonationMessage": "CodonationSelection-module__aKOhcq__zeroCodonationMessage",
});
